import { Pagination, styled } from "@mui/material";
import { ColorSAP } from "../../ontego-ui";

const Styled = {};

Styled.CustomPagination = styled(Pagination)`
    & .MuiPaginationItem-root {
        color: ${ColorSAP.neutral[40]},
    }

    & .MuiPaginationItem-page.Mui-selected {
        backgroundColor: ${ColorSAP.primary[50]},
        color: ${ColorSAP.neutral[0]},
    }
`;

export default Styled;